export const calculatePlaceHolderTop = (
  parentElement: HTMLElement,
  dropIndex: number,
  sourceIndex: number,
): string => {
  if (dropIndex === 0) return '0';
  if (dropIndex === -1) return '-10000px';

  const effectIndex = dropIndex > sourceIndex ? dropIndex : dropIndex - 1;
  const prevElem = parentElement.children.item(effectIndex);
  const prevStyle = window.getComputedStyle(prevElem);
  const y = `calc(${(prevElem as HTMLElement).offsetTop}px + ${
    prevStyle.height
  } + ${prevStyle.marginBottom})`;

  return y;
};
